// COM-639 fix wave (2026-08-18, Artur): whether a source belongs in the
// Sources-filter dropdown's universe. Refined from the earlier
// "has at least one article" rule (see SourcesContext.tsx's `sourcesLoaded`
// listener for the full history) to a three-case rule:
//   - no error, no articles   -> include (a freshly added/pending source the
//     user should be able to filter by even before it has any articles yet)
//   - articles AND an error   -> include (its articles are already in the
//     feed, so the user must have a checkbox to select them by)
//   - error AND zero articles -> exclude (contributes nothing to the feed
//     and is broken - pure noise in the dropdown)
// i.e. `include = status !== 'error' || articleCount > 0`.
//
// Extracted as a pure, unit-tested function (filterSources.test.ts) rather
// than inlined in the listener - AGENTS.md requires a unit test for every
// new pure function. Lives in `lib/`, not `pages/feedFilters.ts`: this is
// used from `context/SourcesContext.tsx`, and a context importing from
// `pages/` would be backwards layering.
export function shouldOfferSourceInFilter(source: { status: string; articles?: unknown[] }): boolean {
  return source.status !== 'error' || (source.articles?.length ?? 0) > 0;
}
